import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Header, Icon } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

// Components
import ImpresaList from 'components/ProcessoImpresa/ImpresaList';

const TitlteHeader = Styled(Header)`
  margin-top: 15px;
`;

export class ProcessoImpresaList extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Processo imprese</title>
          <meta name="description" content="Processo imprese" />
        </Helmet>

        <TitlteHeader as="h2">
          <Icon name="building" />
          <Header.Content>
            Gestione processo imprese
            <Header.Subheader>Creazione e modifica dei processi impresa</Header.Subheader>
          </Header.Content>
        </TitlteHeader>

        <ImpresaList {...this.props} />
      </div>
    );
  }
}

ProcessoImpresaList.propTypes = {
  /** Used for manage history of the browser -> redirect */
  history: PropTypes.object,
  /** Containes information about the URL -> used for get the neo profile ID  */
  match: PropTypes.object,
  /** Function for call the notification system */
  // notification: PropTypes.func,
  /** Object with data of logged user */
  auth: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(ProcessoImpresaList);



// WEBPACK FOOTER //
// ./app/containers/ProcessoImpresaList/index.js